/** Stable internal tenancy boundary for a host's personal recording account. */
export function personalAccountId(clerkUserId: string): string {
  return `personal:${clerkUserId}`;
}
